import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { CountryManagementService } from '../../../service/country-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { BarCodeCategory, FocusInputType, GeneralConfigType, KeyValues3, KeyValues5, KeyValueSet, LocalService, RelationShipRole, InteractionType, Status, TriggeredEvent, NumericConfig } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { SellerManagementService } from '../../../service/seller-management.service';

@Component({
  selector: 'app-user-authentication',
  templateUrl: './user-authentication.component.html',
  styleUrls: ['./user-authentication.component.scss']
})
export class UserAuthenticationComponent implements OnInit {
  @ViewChild('user_authentication') content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();
  @Input() btnIdToTriggerWhileClose: string = '';

  lstSectionConfigKeys: string[] = ["user_authentication"]; countryId = '';
  wrapper: KeyValues5; @Input() IsCloseAfterCreation = true; ctryCode = ''; @Input() isMultiCustomerTypes = false;
  @Input() BusinessId: string = ''; isForBusiness = false; message = ''; @Input() busineses: KeyValues3[];
  @Input() relationshipRole: number = RelationShipRole.None; relationships: KeyValueSet[]; @Input() IsForceSave = false;
  @Input() relationShipType: number = InteractionType.None; strRelationShipRole = ''; maxBodyHeight = 0;
  brn = ''; isOtpRequired = false; intialRelationShipRole: RelationShipRole; @Input() phoneNumber = '';
  restrictedRoles: string[] = [RelationShipRole.Business.toString()];
  htmlId: string = ''; @Input() userAuthSaveBtnId = '';
  elementIds: any;
  numericConfig: NumericConfig = {} as NumericConfig; isOpenCreateAccount: boolean = false;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public countryManagementService: CountryManagementService, public profileManagementService: ProfileManagementService, private configurationManagementService: ConfigurationManagementService, private sellerManagementService: SellerManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      ph_num: 'auth_ph_num_' + this.htmlId,
      bin: 'auth_bin_' + this.htmlId
    };
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    if (!this.userAuthSaveBtnId)
      this.userAuthSaveBtnId = 'save_user_auth_' + this.htmlId;
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onReset();
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onLoad() {
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.RelationShipRole).subscribe(result => {
      this.relationships = result.filter(x => this.restrictedRoles.indexOf(x.key) == -1);
      this.onRoleSelect();
      if (this.IsForceSave && this.wrapper.value) {
        this.onPopupSave();
      }
    });
  }

  onReset() {
    this.countryId = this.localService.loggedMember ? this.localService.loggedMember.loggedMember.content.v2 : '';
    this.ctryCode = this.localService.selected.countryCode;
    this.numericConfig.maxDecimalDigits = this.localService.getContactMaxDigitByCountryCode(this.localService.getLoginAsCountryCode() )
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.intialRelationShipRole = this.relationshipRole == RelationShipRole.None ? RelationShipRole.EndCustomer : this.relationshipRole;

    this.busineses = null;
    this.wrapper = {
      key: this.BusinessId,
      v1: '0', //Is verified
      v2: this.relationshipRole == RelationShipRole.None ? RelationShipRole.EndCustomer.toString() : this.relationshipRole.toString(),
      v3: '', ////For business id or user id or phone number
      v4: '', //Phone number
      value: this.phoneNumber ? parseInt(this.phoneNumber) : null
    } as KeyValues5;
    this.isOtpRequired = false;
    this.localService.onFocusNextInput(this.elementIds.ph_num, 1);
  }

  onPopupClose(isWithData = false) {
    if (isWithData)
      this.onCloseTrigger({ event: TriggeredEvent.Ok, data: this.brn });
    else
      this.onCloseTrigger({ event: TriggeredEvent.Close });
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onPopupSave(isCreateAcccountClicked = false) {
    if (isCreateAcccountClicked) {// && !this.wrapper.value
      this.onCreateAccountClick();
    }
    else if (this.doCheck()) {
      this.wrapper.v4 = this.wrapper.value ? this.wrapper.value.toString() : '';
      this.profileManagementService.saveRelationShip(this.wrapper).subscribe(result => {
        switch (result.status) {
          case Status.NeedOtpVerification: {
            this.wrapper.v4 = result.id;
            this.isOtpRequired = true;
          } break;
          case Status.UnAvailable: {
            this.onCreateAccountClick();
          } break;
          case Status.LimitExceeded: {
            this.onSelectFromAccount();
          } break;
          case Status.Duplicate:
          case Status.Success: {
            this.onSuccess(result.id);
          } break;
        }
      });
    }
  }

  onSuccess(id) {
    this.brn = id;
    if (this.IsCloseAfterCreation) {
      this.onPopupClose(true);
    } else {
      this.phoneNumber = '';
      this.onReset();
    }
  }

  doCheck() {
    this.message = '';
    if (parseInt(this.wrapper.v2) == RelationShipRole.None) {
      this.message = this.localService.languageContent.user_authentication.invalid_bin;
    }
    //else if (parseInt(this.wrapper.v2) == RelationShipRole.Business && this.wrapper.v3.length != 24) {
    //  this.message = this.localService.languageContent.user_authentication.invalid_bin;
    //  this.localService.onFocusNextInput(this.elementIds.bin, FocusInputType.TextBox);
    //}
    else if (parseInt(this.wrapper.v2) == RelationShipRole.Business && this.wrapper.v3.toLowerCase() == this.BusinessId) {
      this.message = this.localService.languageContent.user_authentication.bin_biz_cannot_same;
      this.localService.onFocusNextInput(this.elementIds.bin, FocusInputType.TextBox);
    }
    return this.message == '';
  }

  onInput(index) {
    if (this.wrapper.v3.length >= 24 && this.wrapper.v3.startsWith(this.localService.barCodePrefix)) {
      this.onQrScanned(this.wrapper.v3);
    } else {
      this.brn = '';
      this.isOtpRequired = false;
      this.wrapper.v1 = '0';
    }
  }

  onSelectFromAccount() {
    this.sellerManagementService.getBusinesesBySearchKey(this.wrapper.v3).subscribe(result => {
      this.busineses = result;
    });
  }

  onBusinessSelected(businessId: string) {
    this.onVerifiedOtpVerified(businessId);
  }

  onCreateAccountClick() {
    if (this.relationshipRole != RelationShipRole.Business) {
      this.isOpenCreateAccount = true;
      this.onCloseTrigger();
    } else {
      this.message = this.localService.languageContent.user_authentication.invalid_biz;
    }
  }

  onCloseCreateAccount(result) {
    if (result) {
      if (result.event == TriggeredEvent.Ok) {
        this.wrapper.v4 = result.data;
        this.isOtpRequired = true;
      }
      else
        this.localService.onFocusNextInput(this.elementIds.ph_num, FocusInputType.TextBox);
    }
  }

  onVerifiedOtpVerified(event) {
    this.wrapper.v3 = event;
    this.wrapper.v1 = '1';
    this.onPopupSave();
  }

  onRoleSelect(isCustomerTypeChanged = false) {
    if (isCustomerTypeChanged) {
      this.relationshipRole = this.isForBusiness ? RelationShipRole.Business : (this.intialRelationShipRole != RelationShipRole.Business ? this.intialRelationShipRole : RelationShipRole.EndCustomer);
      this.wrapper.v2 = this.relationshipRole.toString();
    } else {
      this.isForBusiness = parseInt(this.wrapper.v2) == RelationShipRole.Business;
    }
    this.localService.onFocusNextInput(this.isForBusiness ? this.elementIds.bin : this.elementIds.ph_num, FocusInputType.TextBox);
  }

  onChecked(index) {
    this.onCloseTrigger({ event: TriggeredEvent.Switched });
    //this.isForBusiness = index == 2;
    //this.onRoleSelect(true);
  }

  onQrScanned(value) {
    let qrCode = this.localService.getDecodedQrCode(value);
    if (qrCode.isValid && qrCode.barCodeCategory == BarCodeCategory.Business) {
      this.onCloseTrigger({ event: TriggeredEvent.Scanned, data: value });
    } else {
      this.wrapper.v3 = '';
    }
  }
}
